import React from 'react'
import { Background, Parallax } from 'react-parallax';
import Breadcrumb from '../../../shared/components/atoms/breadcrumb/breadcrumb';
import SectionCaretakersFeatures from '../../molecules/section-caretakers-features/section-caretakers-features';
import SectionCaretakersIntroduction from '../../molecules/section-caretakers-introduction/section-caretakers-introduction';
import SectionCaretakersTummies from '../../molecules/section-caretakers-tummies/section-caretakers-tummies';
import SectionPromotionalBanner from '../../molecules/section-promotional-banner/section-promotional-banner';
import './caretakers-content.scss'

const CaretakersContent = ({ contentInfo }) => {

    return (
        <div className="f-o-caretakers-content">
            <Parallax
                className="f-o-caretakers-content__parallax"
                strength={-1200}>
                <Background className="custom-bg">
                </Background>
            </Parallax>
            <Breadcrumb />
            <SectionCaretakersIntroduction contentInfo={contentInfo} />
            <SectionCaretakersFeatures contentInfo={contentInfo.referenciaContenidoCursoCuidadores.filter(item => item.index[0] === "Contenido3")[0]} />
            <SectionCaretakersTummies contentInfo={contentInfo.referenciaContenidoCursoCuidadores.filter(item => item.index[0] === "Contenido4")[0]} />
            <SectionPromotionalBanner contentInfo={contentInfo.referenciaContenidoCursoCuidadores.filter(item => item.index[0] === "Contenido5")[0]} />
        </div>
    )
}

export default CaretakersContent
